export default function getLastQuestionAnswered(currentQuestions) {
  return currentQuestions && currentQuestions.length
    ? currentQuestions[currentQuestions.length - 1].questionId
    : '';
}
